import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { baseTheme } from "@avenue-8/sidekick-ui";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  padding-bottom: 10rem;

  ${(p) => p.theme.media.mobileDown} {
    padding-bottom: 0;
  }
`;

const Eyebrow = styled(Typography)`
  color: ${(p) => p.theme.colors.white};
  opacity: 0.7;
  margin-bottom: 0.5rem;
  font-weight: 700;
`;

const Headline = styled(Typography)`
  color: ${(p) => p.theme.colors.white};
  max-width: 540px;
  line-height: 1;

  ${(p) => p.theme.media.mobileDown} {
    font-size: 1.75rem;
    line-height: 1.15;
  }
`;

const Body = styled(Typography)`
  color: ${baseTheme.colors.state1};
  max-width: 420px;
  margin-top: 1rem;
`;

const ChildrenContainer = styled.div`
  width: 100%;
  margin-top: 2rem;

  ${(p) => p.theme.media.mobileDown} {
    margin-top: 1.5rem;
  }
`;

type Props = {
  eyebrow?: string;
  headline: string;
  body?: string;
  children?: ReactNode;
};

export const SubscriptionOnboardingHero = ({
  eyebrow,
  headline,
  body,
  children,
}: Props) => (
  <Container>
    {eyebrow && <Eyebrow variant="overline">{eyebrow}</Eyebrow>}
    <Headline variant="h2">{headline}</Headline>
    {body && <Body>{body}</Body>}
    {children && <ChildrenContainer>{children}</ChildrenContainer>}
  </Container>
);
